var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMailbox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M16.1719 4H4.17188C3.64144 4 3.13273 4.21071 2.75766 4.58579C2.38259 4.96086 2.17188 5.46957 2.17188 6V14C2.17188 14.5304 2.38259 15.0391 2.75766 15.4142C3.13273 15.7893 3.64144 16 4.17188 16H16.1719C16.7023 16 17.211 15.7893 17.5861 15.4142C17.9612 15.0391 18.1719 14.5304 18.1719 14V6C18.1719 5.46957 17.9612 4.96086 17.5861 4.58579C17.211 4.21071 16.7023 4 16.1719 4Z",
    stroke: "#484888",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M3.17188 5L6.63588 8.464C7.10019 8.92843 7.65144 9.29685 8.25815 9.5482C8.86487 9.79956 9.51515 9.92893 10.1719 9.92893C10.8286 9.92893 11.4789 9.79956 12.0856 9.5482C12.6923 9.29685 13.2436 8.92843 13.7079 8.464L17.1719 5",
    stroke: "#484888",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailbox);
export default __webpack_public_path__ + "static/media/mailbox.d2b8eee6808ffd2d6053b533fb6c7ccb.svg";
export { ForwardRef as ReactComponent };